import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import Port from 'affiliates/Widget/FerrySearchMask/Port';
import DatePickerWrapper from 'affiliates/Widget/FerrySearchMask/DatePickerWrapper';

const Trip = ({
  isMobile, index, triedToSubmit, trip, noOfTrips, minTrips, maxTrips, popular, errors, disableBefore,
  disableAfter, setPort, fetchSuggestions, clearSuggestions, onSuggestionSelected, portString,
  portStringNo3Ltr, swapPorts, setTypeTrip, setDate, setDates, addTrip, removeTrip, 
  setPortByThreeLetterCode, translations
}) => {

  const {dep: depTr, arr: arrTr, trip: tripTr, addTrip: addTripTr} = translations;

  return (
    <>
      <div className="w-1-1">
        <div className="trip-controls grid no-gutter mb-2">
          <div className="trip-counter grid-item">{tripTr} {index + 1}</div>
          <div className='remove-trip grid-item'>
            <button
              className="btn btn-block"
              type="button"
              disabled={noOfTrips <= minTrips}
              onClick={() => removeTrip(index)}>
              <i className="icon icon-e-remove-2 mt-2" aria-hidden="true"/>
            </button>
          </div>
        </div>
        <div className="grid no-gutter">
          <div className="grid-item mb-2 mr-sm-0 mr-3">
            <Port
              port={trip.dep}
              type='dep'
              selected={trip.depSelected}
              popular={popular}
              popularPorts={trip.depPopularPorts}
              portString={portString}
              portStringNo3Ltr={portStringNo3Ltr}
              onSuggestionSelected={onSuggestionSelected}
              onChange={setPort}
              fetchSuggestions={fetchSuggestions}
              clearSuggestions={clearSuggestions}
              className={{
                input: 'mask-from form-control rounded-0 pr-6',
                suggestion: 'list-group-item px-3'
              }}
              placeholder={depTr}
              swapPorts={swapPorts}
              setPortByThreeLetterCode={setPortByThreeLetterCode}
              tripIndex={index}
              translations={translations}
            />
            {
              triedToSubmit && errors?.[index]?.dep?.[0] &&
              <div className='searchMask-error'>{errors[index].dep[0]}</div>
            }
          </div>
          <div className="grid-item mb-2">
            <Port
              port={trip.arr}
              type='arr'
              selected={trip.arrSelected}
              popular={popular}
              popularPorts={trip.arrPopularPorts}
              portString={portString}
              portStringNo3Ltr={portStringNo3Ltr}
              onSuggestionSelected={onSuggestionSelected}
              onChange={setPort}
              fetchSuggestions={fetchSuggestions}
              clearSuggestions={clearSuggestions}
              className={{
                input: 'mask-to form-control rounded-0 pr-6',
                suggestion: 'list-group-item px-3'
              }}
              placeholder={arrTr}
              tripIndex={index}
              setPortByThreeLetterCode={setPortByThreeLetterCode}
              translations={translations}
            />
            {
              triedToSubmit && errors?.[index]?.arr?.[0] &&
              <div className='searchMask-error'>{errors[index].arr[0]}</div>
            }
          </div>
        </div>
      </div>
      <div className="multi-trip-controls grid m-0 w-1-1">
        <DatePickerWrapper
          isMobile={isMobile}
          cssClass="mask-date p-0"
          tripIndex={index}
          obDate={trip.obDate}
          ibDate={trip.ibDate}
          setRoundTrip={setTypeTrip}
          setDates={setDates}
          setDate={setDate}
          disableBefore={disableBefore}
          disableAfter={disableAfter}
          translations={translations}
        />
        {
          (noOfTrips -1 === index) &&
            <div className="grid-item mb-2 p-0 ml-3">
              <button
                className="add-trip btn btn-block d-flex align-items-center justify-content-center"
                type="button"
                disabled={noOfTrips >= maxTrips}
                onClick={addTrip}>
                <i className="icon icon-e-add-1 mr-2" /> {addTripTr}
              </button>
            </div>
        }
      </div>
    </>
  );
};

Trip.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  triedToSubmit: PropTypes.bool.isRequired,
  trip: PropTypes.object.isRequired,
  noOfTrips: PropTypes.number.isRequired,
  minTrips: PropTypes.number.isRequired,
  maxTrips: PropTypes.number.isRequired,
  popular: PropTypes.bool.isRequired,
  errors: PropTypes.array.isRequired,
  disableBefore: PropTypes.object,
  disableAfter: PropTypes.object,
  setPort: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  portString: PropTypes.func.isRequired,
  portStringNo3Ltr: PropTypes.func.isRequired,
  swapPorts: PropTypes.func.isRequired,
  setTypeTrip: PropTypes.func.isRequired,
  setDate: PropTypes.func.isRequired,
  setDates: PropTypes.func.isRequired,
  addTrip: PropTypes.func.isRequired,
  removeTrip: PropTypes.func.isRequired,
  setPortByThreeLetterCode: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    dep: PropTypes.string.isRequired,
    arr: PropTypes.string.isRequired,
    trip: PropTypes.string.isRequired,
    addTrip: PropTypes.string.isRequired
  })
};

export default observer(Trip);
